import * as React from 'react';
import {useState} from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import {CONTENT_LANGUAGES} from '../../constants/appConstants';
import PollDropdown from './PollDropdown';

export default function CountryCheckbox() {
  const [checked, setChecked] = useState(false)

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked)
  }
  return <>
    <FormGroup>
      <FormControlLabel required control={<Checkbox defaultChecked={checked} onChange={handleCheckboxChange}/>}
                        label="Is it <country name> country specific question?"/>
      {checked && <PollDropdown label={'Content language'} object={CONTENT_LANGUAGES}/>}
    </FormGroup>
  </>
}